import { MutableRefObject, useRef } from 'react';

/**
 * Intializes a ref with the result of a callback. This is useful if the initial value generate is complex/expensive.
 */
export function useRefWithInitializationFunction<T>(
  valueCreator: () => T
): MutableRefObject<T> {
  const ref = useRef<{ current: T }>();

  if (!ref.current) {
    ref.current = { current: valueCreator() };
  }

  return ref.current;
}
